(function () {
    const radioContainers = {},
        radioContent = {};

    /**
     * Copies a description assigned to a radio and stores it in a variable.
     * Once the description was stored, it is removed from the radio.
     * @param radios
     */
    const buildRadioContent = (radios) => {
        radios.forEach(radio => {
            const textContent = radio.closest(".radio-text").querySelector(".text-content");

            // Do not trigger any action if the textContent container is not a DOM Element
            if (textContent instanceof Element) {
                // We get rid of the "d-none" class, as the content is hidden on page load
                textContent.classList.remove("d-none");
                radioContent[radio.id] = textContent;
                textContent.remove();

                // Show the radio text on page load if the radio has been selected
                if (radio.checked === true) {
                    showContent(radio);
                }
            }
        });
    }

    /**
     * Displays the text content assigned to the radio button
     *
     * @param radio
     */
    const showContent = (radio) => {
        if (radio.checked === true) {
            const toggleContentContainer = radio.closest(".radio-toggle").querySelector(".toggle-content");
            const textContent = radioContent[radio.id];

            if (textContent) {
                toggleContentContainer.innerHTML = textContent.innerHTML;
            } else {
                toggleContentContainer.innerHTML = "";
            }
        }
    }

    /**
     * Simulates multiple radio selection
     *
     * @param containerId
     * @param target
     */
    const toggleRadios = (containerId, target) => {
        radioContainers[containerId].forEach(radio => {
            if (radio.id !== target.id) {
                radio.checked = false;
            }
        });
    };

    /**
     * Validates whether a radio has been selected within the group container
     *
     * @param container
     * @returns {boolean}
     */
    const validateContainer = (container) => {
        let hasChecked = false;

        for (let radio of radioContainers[container.id]) {
            if (radio.checked === true) {
                hasChecked = true;
                break;
            }
        }

        return hasChecked;
    }

    /**
     * Registers radio "change" listener and the callbacks
     *
     * @param containerId
     */
    const registerRadioListener = (containerId) => {
        radioContainers[containerId].forEach(radio => {
            radio.addEventListener("change", () => {
                toggleRequired(containerId, false);
                toggleRadios(containerId, radio);
                showContent(radio);

                if (window.Parsley) {
                    const form = document.getElementById(containerId).closest("form");
                    $(form).parsley().refresh();
                    $(form).parsley().validate({group: "radio-text"});
                }
            });
        });
    }

    /**
     * Sets a radio field as (not) required
     *
     * The first radio button from a group is selected as (not) required, so we can stop the form from being submitted
     * if neither of the options has been selected.
     *
     * @param containerId
     * @param state true for required, anything else for not required
     */
    const toggleRequired = (containerId, state) => {
        if (state === true) {
            radioContainers[containerId][0].setAttribute("required", "");
        } else {
            radioContainers[containerId][0].removeAttribute("required");
        }
    }

    /**
     * Handles the form submit event
     *
     * If the required groups has not been selected, then the form won't be submitted.
     *
     * @param containerId
     */
    const registerFormListener = (containerId) => {
        const container = document.getElementById(containerId),
            form = container.closest("form");

        if (form) {
            form.addEventListener("submit", event => {
                if (container.dataset.required === "1" && validateContainer(container) === false) {
                    event.preventDefault();
                    toggleRequired(containerId, true);

                    form.dispatchEvent(new SubmitEvent("submit"));
                }
            });
        }
    }

    // Iterates through all the ".radio-toggle" containers and builds the data based on the content assigned to
    // the radio buttons
    document.querySelectorAll(".radio-toggle").forEach(container => {
        const radios = container.querySelectorAll("input[type=radio]");
        radioContainers[container.id] = radios;
        buildRadioContent(radios);
    });

    // Registers "change" event listeners to each of the custom radios
    for (const containerId in radioContainers) {
        if (radioContainers.hasOwnProperty(containerId)) {
            registerRadioListener(containerId);
            registerFormListener(containerId);
        }
    }
})();